export const SETTINGS_KEY = "settings";
export const DICTIONARY_KEY = "dictionary";
export const COMPARASION_KEYS = [SETTINGS_KEY, DICTIONARY_KEY];
